module.exports = __webpack_public_path__ + "media/da_dk_s4_Ingrid.ec6b699e.oga";